<template>

  <v-row no-gutters>
  <v-col
        cols="7"
        md="7" sm="7"
        class=""
        >

          <div class="outerWrap">
            <!-- start="-15928253.702178 7200979.560690" end="-5439870.428999 2191602.474993"-->
            <div v-if="main_layer"><Map2 id="oecd_m1" type="over1" projection="ESRI:102009"
             start="-5824598.76990786 4510254.59881510" end="3841185.62405755 -3067667.15571821"
             :main_layer="main_layer"/></div>

            <!--Cile-->
            <div v-if="main_layer"><Map2 id="oecd_m12" type="over12"
            start="-8609866.866042 -1457807.003455" end="-7161843.802208 -7582553.205889"
            :main_layer="main_layer"/></div>

            <!-- Hawai -->
            <div v-if="main_layer"><Map2 id="oecd_m13" type="over13"
             start="-17947414.241359 2635548.735273" end="-17174483.011340 2099878.041050" 
             :main_layer="main_layer"/></div>

            <!--div v-if="main_layer"><Map2 id="oecd_m14" type="over14"
            start="-19205873.475047 11691807.846501" end="-14480230.638344 6672646.821183" 
            :main_layer="main_layer"/></div-->

            <!--div v-if="main_layer"><Map2 id="oecd_m15" type="over15"
            start="-9632288.556385 1286588.060096" end="-9172443.394221 851202.746984" 
            :main_layer="main_layer"/></div-->
            <!-- Colombia -->
            <div v-if="main_layer"><Map2 id="oecd_m16" type="over16"
            start="-8893601.115037 1389319.426111" end="-7377090.473859 -577252.437610" 
            :main_layer="main_layer"/></div>
          </div>
    </v-col>


    <v-col
      cols="5"
      md="5" sm="5"
      class=""
      >

      <v-row no-gutters>
        <v-col
          cols="12"
          md="12" sm="12"
        >
          <div class="outerWrap">
            <!--start="-2198206.731464 11603752.389916" end="3522218.263381 3972279.485924"-->
            <div v-if="main_layer"><Map2 id="oecd_m2" type="over2" projection="EPSG:3035"
             start="3130228.46 800629.86" end="5413636.28 5811020.45"
             :main_layer="main_layer"/></div>
             
            <!--div v-if="main_layer"><Map2 id="oecd_m21" type="over21"
             start="-2157358.686321 3979617.440639" end="-1330615.788388 3018345.372925"
             :main_layer="main_layer"/></div-->

            <!--div v-if="main_layer"><Map2 id="oecd_m22" type="over22"
             start="3788830.618040 3940481.682157" end="4002854.297238 3396250.040767" 
             :main_layer="main_layer"/></div-->
          </div>
        </v-col>

      </v-row>

      <v-row no-gutters>
        <v-col
          cols="7"
          md="7" sm="7"
          class=""
          no-gutters
        >          
        <div class="outerWrap">
          <div v-if="main_layer"><Map2 id="oecd_m4" type="over4"
          start="12014677.853977 -900122.445086" end="20037508.342789 -6105178.323194" 
          :main_layer="main_layer"/></div>
        </div>
        </v-col>

        <v-col
          cols="5"
          md="5" sm="5"
          class=""
          
        >          
        <div class="outerWrap">
          <div v-if="main_layer"><Map2 id="oecd_m3" type="over4"
          start="13785570.925288 5786629.523307" end="16456586.441685 3443946.746417" 
          :main_layer="main_layer"/></div>
        </div>        
        </v-col>
      
      </v-row>
      
    </v-col>
  </v-row>
      
</template>

<script>
// import Map from '@/components/Map'
import Map2 from '@/components/Map2'
// import CountryInfoPanel from '@/components/CountryInfoPanel'

import VectorImageLayer from 'ol/layer/VectorImage'

export default {
  name: 'OECDRegions',
  components: {Map2},
  data () {
    let main_layer = null
    //let polygon_layer = null
    return {
      main_layer
    }
  },
    methods: {
    },
  mounted () {
    this.main_layer = new VectorImageLayer({
      name: 'polygon',
      imageRatio: 2,
    })
    this.$forceUpdate()
  }  
}
</script>


<style>
  .outerWrap
    {
    position: relative;
    }
</style>